import OneDriveProScopeType from 'owa-service/lib/contract/OneDriveProScopeType';
import AttachmentDataProviderScope from 'owa-service/lib/contract/AttachmentDataProviderScope';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { isOneDriveProScope } from './typeGuards';

export function getOneDriveProScopeType(
    fileProviderType: AttachmentDataProviderType,
    scope: AttachmentDataProviderScope
): OneDriveProScopeType {
    if (
        fileProviderType === AttachmentDataProviderType.OneDrivePro &&
        scope &&
        isOneDriveProScope(scope)
    ) {
        return scope.Type;
    }

    return null;
}
